import {MuWidget} from "mu-widget/lib/MuWidget";
import {getSelectedValue, setSelectedValue} from "../Utils";

export class UiNumberRange extends MuWidget {
	beforeIndex() {
		this.container.classList.add("display-flex", "flex-items-grow-1");
		this.muAppendContent(`
			<label mu-for="rangeFrom">Od</label>
			<input type="number" mu-bind="rangeFrom" class="form-control display-inline-block w8em">
			<label mu-for="rangeTo">Do</label>
			<input type="number" mu-bind="rangeTo" class="form-control display-inline-block w8em">
		`);
	}
}